import clsx from 'clsx';
import React from 'react';
import { Image } from '../../DataDisplay/Image/Image.mjs';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Typography } from '../../Foundations/Typography/Typography.mjs';
import { Flex } from '../../Layout/Flex/Flex.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './ColorSwatch.module.css.mjs';

const ColorSwatch = polymorphicFactory(
  (props, ref) => {
    const {
      component = "button",
      className,
      colorName,
      colorHex,
      shape = "square",
      size = "small",
      isSelected = false,
      onClick,
      image,
      label,
      disabled,
      ...rest
    } = props;
    const wrapperClassNames = clsx(
      className,
      classes.colorSwatchWrapper,
      isSelected && classes.selected,
      "kohler-color-swatch-root",
      disabled && classes.disabled
    );
    const colorCardClassNames = clsx(
      classes.colorSwatch,
      isSelected && classes.selected,
      classes[shape],
      classes[size],
      "kohler-color-swatch-tag",
      disabled && classes.disabled
    );
    const colorSwatchColorClassnames = clsx("kohler-color-swatch-color", classes.colorSwatchColor, classes[shape], classes[size]);
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        component,
        type: component === "button" ? "button" : void 0,
        ref,
        className: wrapperClassNames,
        onClick,
        ...rest,
        textAlign: "start",
        name: colorName,
        disabled,
        "aria-label": colorName
      },
      /* @__PURE__ */ React.createElement(Flex, { align: "center", justify: "center", className: colorCardClassNames }, image ? /* @__PURE__ */ React.createElement(Flex, { className: colorSwatchColorClassnames }, /* @__PURE__ */ React.createElement(Image, { ...image, opacity: disabled ? 0.5 : 1 })) : /* @__PURE__ */ React.createElement("div", { className: colorSwatchColorClassnames, style: { backgroundColor: disabled ? `${colorHex}80` : colorHex } })),
      label && /* @__PURE__ */ React.createElement(Typography, { size: "label-regular-m", className: classes.colorSwatchLabel }, label)
    );
  }
);

export { ColorSwatch };
